import { Component,  ElementRef,  Input, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { imageatch_detData } from '../../../../@core/interfaces/masters/imageatch_det';
import { PrinterSettings, PrinterSettingsData } from '../../../../@core/interfaces/masters/printersettings';
import { DateService } from '../service/date.service';

@Component({
  selector: 'ngx-patient-log-report-print',
  templateUrl: './patient-log-report-print.component.html',
  styleUrls: ['./patient-log-report-print.component.scss']
})
export class PatientLogReportPrintComponent implements OnInit {

  @Input() data: any[];
  @Input() disable: boolean;
  styleUrl="/assets/css/print.css,/assets/css/a4landscape.css";
  srcname="../.././../../assets/images/white.png";
  psDetails:PrinterSettings;
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
   protected readonly unsubscribe$ = new Subject<void>();
 
  get apiUrl(): string {
    return environment.apiUrl;
  }
  commonId='00000000-0000-0000-0000-000000000000';

  pageName:string;

  @ViewChild('printButton', { static: false }) printButton: ElementRef;  

  @Input() term: string;
  @Input() regNum: string;
  @Input() sourceType: string;
  @Input() admissionNumber: string;
  @Input() action:string;
  @Input() fromDate: Date;
  @Input() toDate: Date;

  constructor(public dateobj: DateService,private iatchSrvc: imageatch_detData,protected psSrvc:PrinterSettingsData) { }

  ngOnInit(): void {
  }

  utcToLocalConversion(date) {
    if (date != null && date != "" && date != undefined) {
      return this.dateobj?.dateUtctoLocalDateAndTime(date);
    }
  }

  findTodayDate()
  {
   return this.dateobj.dateUtctoLocal(new Date(), 'DD-MM-YYYY h:mm:ss a');
  }

  loadPrinterSettingsAndLogo() {
    this.iatchSrvc.getById(environment.apiUrl+"/ImageAtchDet/"+this.tenantId +"/"+this.branchId+ "/downloadTenantImage/logo/Patient Log Management System").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.srcname = 'data:image/jpeg;base64,' + data.blob;
      var ps=data.printerSettings;
    if(ps!=null){​​​
      this.psDetails=ps;
      this.styleUrl="/assets/css/print.css,/assets/css/"+(this.psDetails.paperSize).toLowerCase()+(this.psDetails.orientation).toLowerCase()+".css";
      this.psDetails.topHeaderLogoPosition="center "+this.psDetails.topHeaderLogoPosition;
      this.psDetails.topHeaderPosition="center "+this.psDetails.topHeaderPosition;
      this.psDetails.reportHeaderPlacement="center "+this.psDetails.reportHeaderPlacement;
      this.psDetails.topHeaderLogoRequired=this.psDetails.topHeaderLogoRequired =="1" ? true : false;
      this.psDetails.topHeaderRequired=this.psDetails.topHeaderRequired =="1" ? true : false;
      this.psDetails.bottomFooterLogoPosition="center "+this.psDetails.bottomFooterLogoPosition;
      this.psDetails.bottomFooterPosition="center "+this.psDetails.bottomFooterPosition;
      this.psDetails.bottomFooterLogoRequired=this.psDetails.bottomFooterLogoRequired =="1" ? true : false;
      this.psDetails.bottomFooterRequired=this.psDetails.bottomFooterRequired =="1" ? true : false;
     }
     else{
      this.styleUrl="/assets/css/print.css,/assets/css/a4landscape.css";
     }   
      }, (error) => {
      }, () => {
      });
  }

  triggerPrint() {
   
    if (this.printButton && this.printButton.nativeElement) {
      this.printButton.nativeElement.click();
    }
  }

}
